// Mirrors src/components/common/FilterTabs.tsx — segmented pill row.
// Selected pill: primaryBg + primary text, semibold.

import React from 'react'
import clsx from 'clsx'

interface FilterOption {
  label: string
  value: string
}

interface FilterTabsProps {
  options: readonly FilterOption[]
  selected: string
  onSelect: (value: string) => void
}

export const FilterTabs: React.FC<FilterTabsProps> = ({options, selected, onSelect}) => (
  <div className="flex gap-xs">
    {options.map(opt => {
      const isSelected = selected === opt.value
      return (
        <button
          key={opt.value}
          type="button"
          onClick={() => onSelect(opt.value)}
          className={clsx(
            'rounded-md px-lg py-sm text-md',
            isSelected
              ? 'bg-primaryBg font-semibold text-primary'
              : 'font-medium text-textSecondary hover:text-textPrimary',
          )}
        >
          {opt.label}
        </button>
      )
    })}
  </div>
)
